// empty file prevent babel-plugin-import error
import '../../../../lib/animate/style';
